import "./tailwind.css";
import { MobileMenu } from "./utils/mobile";

console.debug("index");



window.onload = () => {

  const mobile_nav = document.getElementById("mobile_nav");
  console.debug("Mobile Nav", mobile_nav);
  if (mobile_nav) {
    const mobileMenu = new MobileMenu();
    console.debug("Mobile Nav", mobile_nav);
    mobile_nav.addEventListener("click", mobileMenu.mobile_nav);
    const menu_close = document.getElementById("menu_close");
    if (menu_close) {
      menu_close.addEventListener("click", mobileMenu.mobile_nav);
    }
  } else {
    const observer = new MutationObserver(() => {
      const mobile_nav = document.getElementById("mobile_nav");
      if (mobile_nav) {
        const mobileMenu = new MobileMenu();
        console.debug("Mobile Nav", mobile_nav);
        mobile_nav.addEventListener("click", mobileMenu.mobile_nav);
        const menu_close = document.getElementById("menu_close");
        if (menu_close) {
          menu_close.addEventListener("click", mobileMenu.mobile_nav);
        }
        // Arrête l'observation
        observer.disconnect();
      }
    });
  }
  window.addEventListener("scroll", () => {
    const scrollpos = window.scrollY;
    const header = document.getElementById("header");

    if (scrollpos > 0 && header) {
      header.classList.add("shadow-md");
      header.classList.remove("shadow-none");
    } else if (scrollpos <= 0 && header) {
      header.classList.add("shadow-none");
      header.classList.remove("shadow-md");
    }
  });
};
